import { connect } from 'react-redux';

import { verifyEmailAction } from '../../actions/session_actions';

import { withRouter } from 'react-router-dom';

import VerifyEmail from './verify_email';

const mapStateToProps = (state, ownProps) => {
  
  const loggedIn = Boolean(state.session.currentUser);
  const errors = state.errors.session;

  return {
    loggedIn,
    errors
  };
};

const mapDispatchToProps = (dispatch, { location }) => {
  return {
    verifyEmail: link => dispatch(verifyEmailAction(link)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VerifyEmail)
);
